export const BORDER = {
    _16px: '1.6vh',
    _8px: '0.8vh'
};